import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { loadIcon } from 'utils/filesUtils';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import GlobalTooltip from 'components/GlobalTooltip';
import { useContext } from 'react';
import { UserDetailsContext } from 'context/userDetailsContext';
import { useHistory, useLocation } from 'react-router-dom';

export const TitleTemplate = ({ rowData, event, isGlobalFileManager }) => {
  const {
    handleBreadCrumbs,
    setSelectedItem,
    modals,
    onFilterChange,
    files,
    setPreviewList,
    setSelectedPreviewItem,
    isClientFileManager,
    fileManagerFilters,
  } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  const { setShowPreview, setShowAddTag, setTagModalType, setShowUploadedVersionsModal } = modals;
  const sanitizedPk = rowData?.pk?.replace(/[^a-zA-Z0-9_-]/g, '_') || '';
  const tagArray = rowData?.tags || [];
  const displayedTags = tagArray.slice(0, 1); // Show only the first 2 tags
  const remainingTags = tagArray.slice(1);
  const history = useHistory();
  const location = useLocation();

  const setQuery = (data) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('file_id', data?.object_id);

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const selectFile = (e) => {
    if (e.entry_type === 'folder') {
      handleBreadCrumbs(e);
      // let obj = {
      //   case_id: isGlobalFileManager || isClientFileManager ? '' : caseDetails.case_id,
      //   selectedFolder: e.object_id,
      //   selectedType: '',
      //   tag: '',
      //   query: '',
      //   folder_id: '',
      // };
      // getFiles(obj, currentView, pageLimit);

      // Check if this is a shared folder and current user is a client
      const isSharedFolder = e.folder_shared === true;
      const isClientUser = userContext?.access_level === 'client';
      const hasFolderId = e.object_id && e.object_id !== '' && e.object_id !== 'undefined';
      const isCurrentlyInSharedMode = fileManagerFilters?.shared_folder === true;

      // Set shared_folder: true when:
      // 1. Client user clicking INTO any folder with valid folder_id when already in shared mode, OR
      // 2. Client user clicking INTO a shared folder for the first time
      const shouldSetSharedFolder = isClientUser && hasFolderId && (isCurrentlyInSharedMode || isSharedFolder);

      let data = {
        target: {
          name: 'selectedFolder',
        },
        value: e.object_id,
        // Set shared_folder: true when client clicks any folder in shared mode or shared folder for first time
        // Otherwise preserve the current shared_folder state if it exists
        ...(shouldSetSharedFolder ? { shared_folder: true } : isCurrentlyInSharedMode ? { shared_folder: true } : {}),
        // Only set folder_shared and shared_contact_list for actually shared folders
        folder_shared: e.entry_type === 'folder' && isSharedFolder && e.file_shared_contact_id ? true : null,
        shared_contact_list: e.entry_type === 'folder' && isSharedFolder && e.file_shared_contact_id ? e.file_shared_contact_id : null,
      };
      onFilterChange(data);
    } else {
      setQuery(e);
      // setShowPreview(true);
      // setPreviewList(files);
      // setSelectedPreviewItem(e);
    }
  };

  function handleTitleClick() {
    if (!rowData?.case_id || rowData?.case_id === 'undefined') {
      // setNotLinkedToCase(true);
      // setSelectedCase("");
    } else {
      // getCaseObject(rowData?.case_id);
    }

    selectFile(rowData);
  }

  function handleTagClick(type) {
    setShowAddTag(true);
    setTagModalType(type);
    setSelectedItem(rowData);
  }

  function handleVersionControlClick() {
    setSelectedItem(rowData);
    setShowUploadedVersionsModal(true);
  }

  return (
    <>
      <div className="d-flex text-break flex-sm-row w-100">
        <span className="p-column-title text-break">Name</span>
        <div className="text-truncate">
          <span className="d-flex pointer align-items-center text-truncate">
            <span className="d-flex" onClick={handleTitleClick}>
              {rowData?.entry_type === 'folder' ? (
                <i className="icon-folder fa-lg"></i>
              ) : (
                loadIcon(rowData?.display_name?.split('.')?.reverse()[0])
              )}
            </span>
            <span className="ms-2 text-truncate">
              <span
                onClick={handleTitleClick}
                title={rowData.display_name}
                className={
                  rowData.is_read === true || rowData?.is_read === undefined
                    ? 'pointer text-break text-primary-dark'
                    : 'pointer text-bold text-primary-dark'
                }
              >
                {rowData.display_name}
              </span>
            </span>
            {rowData?.entry_type !== 'folder' && rowData?.versions?.length > 0 ? (
              <span role="button" onClick={handleVersionControlClick}>
                <GlobalTooltip tooltip="File Versions" className="ms-2">
                  <i className="fas fa-history" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            ) : null}
          </span>

          {!isClientFileManager && !isGlobalFileManager && (
            <div className="tag-wrp d-flex flex-wrap pt-2">
              {rowData && rowData.tags && rowData.tags.length ? (
                // <>
                //   {rowData.tags.map((val, index) => (
                //     <span
                //       key={index}
                //       className={'tag m-1 ms-0 pointer ' + (isClosed ? 'pe-none opacity-25' : '')}
                //       onClick={() => handleTagClick('edit')}
                //     >{`#${val.replaceAll('#', '')}  `}</span>
                //   ))}
                //   <i onClick={() => handleTagClick('edit')} className="tag icon-add m-1 ms-0 pointer d-flex align-items-center"></i>
                // </>
                <>
                  {displayedTags.map((val, index) => (
                    <span className="text-break file-manager-ellipsis-text" title={val} key={index}>
                      <Tag value={val} className="case-d-tag me-1 mb-1 case-list-tag-ellipsis-text " />
                    </span>
                  ))}

                  {/* Show "+more" if there are more than 2 tags */}
                  {remainingTags.length > 0 && (
                    <>
                      <Tag
                        className={`p-mr-2 me-1 mb-1 tag case-d-tag more-tag more-tag-${sanitizedPk}`}
                        rounded
                        value={`+${remainingTags.length} more`}
                      />
                      <Tooltip target={`.more-tag-${sanitizedPk}`} position="top">
                        {remainingTags.map((tag, index) => (
                          <Tag key={index} value={tag} className="case-d-tag me-1 mb-1" />
                        ))}
                      </Tooltip>
                    </>
                  )}
                  <i onClick={() => handleTagClick('edit')} className="tag icon-add ms-0 pointer d-flex align-items-center"></i>
                </>
              ) : (
                <span className="F-size12 tag m-1 ms-0 pointer" onClick={(e) => handleTagClick('add')}>
                  <i className="icon-add"></i>Add Tag
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
